import { marked } from 'marked';
import sanitizeHtml from 'sanitize-html';

export const toSafeMarkup = (
  value: string,
  options: {
    useMarkdown?: boolean;
  } = {}
): string => {
  const { useMarkdown = false } = options;
  const html = useMarkdown ? marked(value) : value;

  return sanitizeHtml(html as string, {
    allowedTags: [
      'br',
      'strong',
      'a',
      'em',
      'b',
      'i',
      'p',
      'div',
      'ul',
      'ol',
      'li',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'u',
    ],
    allowedAttributes: {
      a: ['href', 'target', 'rel', 'data-modal', 'data-modal-payload'],
      '*': ['style'],
    },
    transformTags: {
      a: (tagName, attribs) => {
        const href = attribs.href;
        const isAbsoluteUrl = href && (href.startsWith('http://') || href.startsWith('https://'));

        if (isAbsoluteUrl || attribs.target === '_blank') {
          return {
            tagName,
            attribs: {
              ...attribs,
              target: '_blank',
              rel: 'noopener noreferrer',
            },
          };
        }

        // For relative URLs that are not using target="_blank"
        return {
          tagName,
          attribs,
        };
      },
    },
  });
};
